exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.required {\n  font-weight: bold;\n  color: red;\n  font-size: 1.5em;\n}\n", ""]);

// exports
